<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-n-title">
      {{$t('maintenance.network.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-n-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-n-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-n-name-label">
                  {{ $t('maintenance.network.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-n-form-name"
                  type="text"
                  v-model="nForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.network.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-n-collection-label">
                  {{ $t('maintenance.network.create.exposed_to_open_networks_label') }}
                </label>
                <b-form-radio-group
                  v-model="nForm.exposed_to_open_networks"
                  :options="radioOptions"
                  qid="create-n-form-collection"
                ></b-form-radio-group>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-n-cancel-button"
              >
                {{ $t('maintenance.network.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        variant="success"
                        :disabled="buttonDisabled"
                        qid="create-n-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.network.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateNetwork',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.network.title'),
            to: '/maintenance/network'
          },
          {
            text: this.$t('maintenance.network.create.title'),
            active: true
          }
        ],
        nForm: {
          name: '',
          exposed_to_open_networks: '',
          client:'',
        },
        error: '',
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/network')
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.nForm.name);
        formData.append("exposed_to_open_networks", this.nForm.exposed_to_open_networks);
        formData.append("client", this.getClient.slug);

        // Post FormData object to API
        piincHttp.post('/networks', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.network.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Print whole array of actual errors beside message
            self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
          }
        })
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
